<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-progress-linear
                           v-if="requestingApi"
                           class="mb-2"
                           indeterminate
                           color="yellow-darken-2"></v-progress-linear>
        <v-btn v-if="isAdmin" :disabled="requestingApi" color="orange" @click="newItem()">
          <v-icon class="mr-2">mdi-tray-plus</v-icon>
          Adicionar
        </v-btn>
        <v-btn color="success" @click="submitUpdate()" :disabled="!dirty">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-col>
      <v-col cols="12">
        <TreeView
                  :user="user"
                  v-model="lstObjects"
                  childrenKey="sub_categories"
                  :level="0"
                  @itemAdded="dirty = true" />
      </v-col>
      <v-col cols="12" v-if="maxPage > 1">
        <v-pagination
                      :disabled="requestingApi"
                      v-model="page"
                      :length="maxPage">
        </v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import TreeView from "../components/TreeView.vue";
import api from '@/services'
export default {
  components: { TreeView },
  props: {
    user: Object,
  },
  data() {
    return {
      dirty: false,
      requestingApi: false,
      tab: 1,
      lstObjects: [],
      // allExpanded: false,
      filters: {
        itemsPerPage: 100,
      },
      editSubGroup: {},
      dialogCreateEdit: false,
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.submitSearch();
  },
  mounted() { },
  activated() { },
  methods: {
    newItem() {
      const vm = this;

      vm.lstObjects.unshift({ sub_categories: [] });
      vm.dirty = true;
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.cashFlowCategory
            .list(vm.filters, page || 1)
            .then((result) => {
              vm.lstObjects = result?.data;
              // vm.expandItems(vm.allExpanded)
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              // vm.$notify({
              //   type: "success",
              //   text: "Pesquisa concluída",
              // });
              vm.dirty = false;
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    listLastLevel(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.cashFlowCategory
            .listLastLevel(vm.filters, page || 1)
            .then((result) => {
              console.debug(result?.data)
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    // expandAll(items, showTree) {
    //   items.forEach(obj => {
    //     obj.showTree = showTree
    //     if (obj.sub_categories) {
    //       obj.sub_categories = this.expandAll(obj.sub_categories, showTree)
    //     }
    //   });
    //   return items
    // },
    // expandItems(showTree) {
    //   var vm = this
    //   let _result = vm.expandAll(vm.lstObjects, showTree)
    //   vm.lstObjects = _result
    //   console.debug(_result)
    // },
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.cashFlowCategory
          .update({
            items: vm.lstObjects
          })
          .then((result) => {
            vm.requestingApi = false;
            vm.$notify({
              type: "success",
              text: "Dados alterados",
            });
            vm.submitSearch();
          })
          .catch((err) => {
            vm.requestingApi = false;
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
      });
    }
  },
  computed: {
    isAdmin() {
      const vm = this;

      return vm.user?.access_level >= 777;
    }
  },
  watch: {
    // allExpanded(newVal) {
    //   this.expandItems(newVal)
    // },
    // c_lstObjects(newVal) {
    //   console.debug(newVal)
    //   if (!newVal || newVal.length <= 0) {
    //     this.lstObjects = [{
    //       name: '',
    //       type: null,
    //       sub_categories: [],
    //     }]
    //   }
    // },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>